import { render, staticRenderFns } from "./WebpartManagement.vue?vue&type=template&id=4eeb288e"
import script from "./WebpartManagement.ts?vue&type=script&lang=ts&external"
export * from "./WebpartManagement.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports